/* @flow */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import YouTube from 'react-youtube'
import Simplert from 'react-simplert'
import Rating from 'react-rating'
import { Translate, I18n } from 'react-redux-i18n'
import { Tabs, Tab, Toolbar } from '@material-ui/core';
import _ from 'lodash'

import './style.css'
import {
  getResources,
  hide360,
  hideLogin,
  login,
  initAuth,
  register,
  toRegister,
  search,
  hideAlert,
  forgotPassword,
  showLoading,
  hideMessageModal,
  sendMessage,
  getMessages
} from '../../actions/global'
import Navbar from '../../components/Navbar'
import Modal from '../../components/Modal'
import Divider from '../../components/Divider'
import Button from '../../components/Button'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import SocialButton from '../../components/SocialButton'
import navReducer, { SecondaryNavContextProvider, useSecondaryNavState } from '../../reducers/nav'

const StickyNavbar = (props) => {
  const hashtags = []
  const [sectionValue, setSectionValue] = useState(0)
  const [{ secondaryNav }, dispatch] = useSecondaryNavState()
  let navbar = <Navbar />

  const listenToScroll = _.debounce(() => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop

    // TODO: control navbar fixed??
    if (scrollTop >= 80) {
      // setSecondaryNav(<Navbar />)
    }
    
    // Bottom toolbar
    if (scrollTop >= 360) {
      dispatch({ type: 'setSecondaryNav', value: true })
    } else {
      dispatch({ type: 'setSecondaryNav', value: false })
    }

    if (!hashtags.length) {
      for(let i = 0; i < 7; i++) {
        let elem = document.querySelector('a[name="'+i+'"]')
        if (elem) {
          hashtags.push(elem.offsetTop)
        } else {
          break
        }
      }
    }

    let inside = false
    let i = 0
    for(i = 0; i < hashtags.length && !inside; i++) {
      if (scrollTop >= (hashtags[i] - 160) && scrollTop < (hashtags[i+1] - 160)) {
        setSectionValue(i)
        inside = true
      }
    }
    if (scrollTop >= (hashtags[hashtags.length-1] - 160)) {
      setSectionValue(hashtags.length-1)
    }
    // console.log('hashtag: ', document.querySelector('a[name="1"]'))
  }, 50)

  // = ComponentDidMount since 'empty arrray' to watch
  useEffect(() => {
    window.addEventListener('scroll', listenToScroll)

    return () => {
      // Called just before the component unmount
      window.removeEventListener('scroll', listenToScroll)
    }
  }, [])

  const jumpTo = (event, section) => {
    setSectionValue(section)
    document.location.href = document.location.href.split('#')[0]+'#'+section
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    window.scrollTo(0, scrollTop - 80)
  }

  const secondaryNavbar = <Tabs
    value={sectionValue}
    onChange={jumpTo}
    variant="scrollable"
    scrollButtons="on"
    indicatorColor="primary"
    textColor="primary"
    className="navbar navbar-sticky"
    {...props}
  >
    <Tab key="pricePackages" label={<Translate className="title" value="pricePackages" />} />
    <Tab key="activityIntro" label={<Translate className="title" value="activityIntro" />} />
    <Tab key="activityContents" label={<Translate className="title" value="activityContents" />} />
    <Tab key="activityLimitations" label={<Translate className="title" value="activityLimitations" />} />
    <Tab key="activityNotices" label={<Translate className="title" value="activityNotices" />} />
    <Tab key="cancelRules" label={<Translate className="title" value="cancelRules" />} />
    <Tab key="assemblyPlace" label={<Translate className="title" value="assemblyPlace" />} />
  </Tabs>

  if (props.hassecondarynav && secondaryNav) {
    navbar = secondaryNavbar
  }

  return navbar
}

type WrapperProps = {}
class Wrapper extends React.Component<WrapperProps> {
  constructor(props) {
    super(props)
    this.state = {
      passwordConfirmed: null,
      forgotPassword: false,
      messageTitle: '',
      messageContent: '',
      sectionValue: 0,
    }
  }

  componentDidMount() {
    const {
      showLoading,
      initAuth,
      getResources
    } = this.props
    showLoading()
    initAuth()
    getResources()
  }

  onSubmit(event) {
    event.preventDefault()
  }

  render() {
    const {
      route,
      isLoading,
      navigate,
      notifications,
      isVideoModalShown,
      hide360,
      item360,
      isLoginModalShown,
      hideLogin,
      alert,
      hideAlert,
      search,
      isMessageModalShown,
      hideMessageModal,
      messageModalParams,
      sendMessage,
      account,
      locale,
    } = this.props
    const {
      messageTitle,
      messageContent
    } = this.state

    const ytOptions = {
      height: window.innerHeight * .8,
    }
    const loginInputPassword = I18n.t('password') + ' ...'
    const loginText = I18n.t('login').toUpperCase()
    const registerText = I18n.t('register').toUpperCase()

    return <SecondaryNavContextProvider reducer={navReducer}>
      <div className="wrapper">
        {/* <Sticky topOffset={80}>
          {
            ({
              style,
              isSticky,
              distanceFromTop,
            }) => {
              let className = ''
              if ( && distanceFromTop <= -240) {
                return 
              } else {
                if (distanceFromTop <= -80) {
                  className = 'navbar-sticky'
                }
                return (
                  
                )
              }
            }
          }
        </Sticky> */}
        <StickyNavbar hassecondarynav={route && route.pathname.indexOf('/activity/') === 0 ? 1 : 0} />
        <Toolbar />
        {this.props.children}
      </div>

      <Notifications notifications={notifications} />

      <Modal isShown={isVideoModalShown}
        theaterMode={true}
        close={hide360}>
        <YouTube className="yt-player"
          videoId={item360.videoId}
          opts={ytOptions} />
        <div className="title">
          <div className="subtitle">{item360.location && item360.location[locale]}</div>
          { item360.name && item360.name[locale] }
        </div>
        <div className="brief">
          <label>
            <Translate value="divingDifficulty" className="label" />
            <Rating
              readonly={true}
              emptySymbol={<div className="icon icon-rating-none" />}
              fullSymbol={<div className="icon icon-rating" />}
              initialRating={parseInt(item360.difficulty, 10)} />
          </label>
          <label>
            <Translate value="divingMethod" className="label" />
            { item360.divingMethod && item360.divingMethod.split(',').map((method) => I18n.t(method)).join('、') }
          </label>
          <label>
            <Translate value="species" className="label" />
            <Rating
              readonly={true}
              emptySymbol={<div className="icon icon-fish icon-empty" />}
              fullSymbol={<div className="icon icon-fish" />}
              initialRating={parseInt(item360.species, 10)} />
          </label>
          <label>
            <Translate value="terrain" className="label" />
            <Rating
              readonly={true}
              emptySymbol={<div className="icon icon-camera icon-empty" />}
              fullSymbol={<div className="icon icon-camera icon-empty" />}
              initialRating={parseInt(item360.terrain, 10)} />
          </label>
          <label>
            <Translate value="bestSeason" className="label" />
            { item360.bestSeason && item360.bestSeason[locale] }
          </label>
        </div>
        <div className="intro">
          { item360.intro && item360.intro[locale] }
        </div>
        <div className="footer">
          <Button type="action"
            text={I18n.t('findActivityAround')}
            onClick={(e) => {
              hide360()
              search(item360.location)
              navigate('/search')
            }} />
        </div>
      </Modal>

      <Modal isShown={isLoginModalShown}
        close={hideLogin}>
        { this.props.registerInfo ? 
          <div className="login-modal">
            <form onSubmit={this.onSubmit}>
              <div className="login-options">
                <Translate className="modal-header" value="registerNewAccount" />
                <div className="divider-h">
                  <Translate className="modal-label" value="account" />
                  <input type="email"
                    autoComplete="email"
                    placeholder="email ..."
                    ref="registerEmail"
                    value={this.props.registerInfo.email} />
                </div>
                <div className="divider-h">
                  <Translate className="modal-label" value="password" />
                  <input type="password"
                    placeholder={loginInputPassword}
                    onChange={this.checkPasswordConfirm}
                    autoComplete="new-password"
                    ref="registerPassword" />
                </div>
                <div className="divider-h">
                  <Translate className="modal-label" value="confirmPassword" />
                  <input className="m-r-sm"
                    type="password"
                    placeholder={loginInputPassword}
                    onChange={this.checkPasswordConfirm}
                    ref="registerConfirm" />
                  { this.state.passwordConfirmed ?
                    <i className="icon icon-round success icon-checked" /> : null }
                </div>
                <div className="divider-h">
                  <Button
                    onClick={() => this.props.register({
                      email: this.refs.registerEmail.value,
                      password: this.refs.registerPassword.value,
                    })}
                    text={registerText} />
                </div>
              </div>
            </form>
          </div> : this.state.forgotPassword ?
          <div className="login-modal">
            <form onSubmit={this.onSubmit}>
              <div className="login-options">
                <Translate className="modal-header" value="plzInputEmail" />
                <div className="divider-h">
                  <Translate className="modal-label" value="email" />
                  <input type="email" placeholder="email ..." ref="email" />
                  <Button
                    text={I18n.t('send')}
                    onClick={(e) => {
                      this.props.forgotPassword(this.refs.email.value)
                      this.setState({ forgotPassword: false })
                      this.props.hideLogin(e)
                    }}
                  />
                </div>
              </div>
            </form>
          </div> :
          <div className="login-modal">
            <form onSubmit={this.onSubmit}>
              <div className="login-options">
                <Translate className="modal-header" value="plzLoginWithAccPwd" />
                <div className="divider-h">
                  <Translate className="modal-label" value="account" />
                  <input type="email" placeholder="email ..." ref="email" />
                </div>
                <div className="divider-h">
                  <Translate className="modal-label" value="password" />
                  <input type="password" placeholder={loginInputPassword} ref="password" />
                </div>
                <div className="divider-h">
                  <Button
                    onClick={() => this.props.login({
                      email: this.refs.email.value,
                      password: this.refs.password.value
                    })}
                    text={loginText} />
                  <Button
                    onClick={() => this.props.toRegister()}
                    text={registerText} />
                </div>
                <div className="divider-h">
                  <a onClick={(e) => this.setState({ forgotPassword: true })}>
                    <Translate value="forgotPassword" />
                  </a>
                </div>
                <div className="divider-h">
                  <Divider height={1} width={100} className="border" />
                  <Translate className="divider-text" value="or" />
                  <Divider height={1} width={100} className="border" />
                </div>
                <div className="divider-h">                
                  <SocialButton type="google" onClick={() => this.props.login({ provider: 'google' })} />
                  <SocialButton type="facebook" onClick={() => this.props.login({ provider: 'facebook' })} />
                </div>
              </div>
            </form>
          </div>
        }
      </Modal>

      <Simplert
        showSimplert={ alert.isShown }
        type={ alert.type }
        title={ alert.title }
        message={ alert.message }
        useConfirmBtn={ alert.useConfirmBtn }
        onConfirm={() => alert.onConfirm() && hideAlert() }
        onClose={() => {
          alert.onClose && alert.onClose()
          hideAlert()
        }}
      />

      { isLoading ?
        <div className="init-loading">
          <img src="/init-loading.png" alt="loading" />
        </div> : null
      }

      <Modal isShown={isMessageModalShown}
        close={hideMessageModal}>
        <form className="message-modal" onSubmit={this.onSubmit}>
          <h2>{I18n.t('askActivity')}</h2>
          <Header title={messageModalParams.activityName} />
          <label>
            <Translate className="label" value="title" />
            <input value={messageTitle}
              onChange={(e) => this.setState({ messageTitle: e.target.value })}
            />
          </label>
          <label>
            <Translate className="label" value="message" />
            <textarea value={messageContent}
              onChange={(e) => this.setState({ messageContent: e.target.value })}
            />
          </label>
          <Button type="action"
            text={I18n.t('send')}
            onClick={(e) => sendMessage({
              type: 'activity',
              activityName: messageModalParams.activityName,
              shopId: messageModalParams.shopId,
              creator: account.displayName,
              email: account.email,
              title: messageTitle,
              message: messageContent,
              status: 'unread'
            })}
          />
        </form>
      </Modal>
      <Footer />
    </SecondaryNavContextProvider>
  }
}

const mapStateToProps = state => ({
  route: state.router.location,
  isLoading: state.global.isLoading,
  notifications: state.notifications,
  isVideoModalShown: state.global.isVideoModalShown,  
  item360: state.global.item360,
  isLoginModalShown: state.global.isLoginModalShown,
  isMessageModalShown: state.global.isMessageModalShown,
  messageModalParams: state.global.messageModalParams,
  registerInfo: state.global.registerInfo,
  alert: state.global.alert,
  account: state.global.user,
  locale: state.i18n.locale,
})

const mapDispatchToProps = dispatch => ({
  showLoading: () => dispatch(showLoading()),
  navigate: (location, args) => {
    window.scrollTo(0, 0)
    dispatch(push(location, args))
  },
  initAuth: () => dispatch(initAuth()),
  getResources: () => dispatch(getResources()),
  hide360: (videoId) => dispatch(hide360()),
  hideLogin: (e) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(hideLogin())
  },
  login: (params) => dispatch(login(params)),
  // setLoginResult: (user) => dispatch(setLoginResult(user)),
  register: (params) => dispatch(register(params)),
  toRegister: () => dispatch(toRegister()),
  forgotPassword: (email) => dispatch(forgotPassword(email)),
  search: (keyword) => dispatch(search(keyword)),
  hideAlert: () => dispatch(hideAlert()),
  hideMessageModal: () => dispatch(hideMessageModal()),
  getMessages: (email) => dispatch(getMessages(email)),
  sendMessage: (messageInfo) => dispatch(sendMessage(messageInfo)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Wrapper)


// WEBPACK FOOTER //
// ./src/containers/Wrapper/index.js